import React from 'react';

import ErrorIcon from '@atlaskit/icon/core/status-error';
import InfoIcon from '@atlaskit/icon/core/status-information';
import SuccessIcon from '@atlaskit/icon/core/status-success';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

type FlagType = 'error' | 'info' | 'normal' | 'success' | 'warning';

const flagIconByType: Partial<Record<FlagType, JSX.Element>> = {
	error: <ErrorIcon spacing="spacious" label="" color={token('color.icon.danger')} />,
	warning: <WarningIcon spacing="spacious" label="" color={token('color.icon.warning')} />,
	info: <InfoIcon spacing="spacious" label="" color={token('color.icon.information')} />,
};

const DefaultIcon = <SuccessIcon spacing="spacious" label="" color={token('color.icon.success')} />;

export const getTypeIcon = (type: FlagType = 'normal'): JSX.Element =>
	flagIconByType[type] || DefaultIcon;
